import { createFileRoute } from '@tanstack/react-router';
import { InstructorGrowthLandingPage } from '@pages/instructor-growth-landing';

export const Route = createFileRoute('/$locale/instructor-growth-operating-system')({
  component: InstructorGrowthOperatingSystemRoute,
});

function InstructorGrowthOperatingSystemRoute() {
  const { locale } = Route.useParams();

  return <InstructorGrowthLandingPage locale={locale} />;
}
